import React from "react";
import styles from "./Services.module.css";

const Services = () => {
  return (
    <div className={styles.body}>
      <div className={styles.hero}>
        <div className={`${styles.navbar} container`}>
          <div className={styles.navbar__logo}>
            <img
              src="src/images/Logo/LogoWhite.svg"
              alt="Logo"
              className={styles.navbar__logo_image}
            />
            <div className={styles.navbar__logo_text}>Start</div>
          </div>
          <div className={`${styles.navbar__menu} ${styles.hidden}`}>
            <a href="index.html" className={styles.navbar__menu_1}>
              Home
            </a>
            <a href="portfolio.html" className={styles.navbar__menu_2}>
              Portfolio
            </a>
            <a href="services.html" className={styles.navbar__menu_3}>
              Services
            </a>
            <a href="contact.html" className={styles.navbar__menu_4}>
              Contact
            </a>
          </div>
          <div className={styles.navbar__icons}>
            <i className="bi bi-list"></i>
            <i className={`bi bi-x-lg ${styles.hide}`}></i>
          </div>
        </div>
      </div>

      <div className={styles.sectionOne}>
        <div
          className={`${styles.sectionOne__content} ${styles.textCenter} ${styles.flex}`}
        >
          <div
            className={`${styles.sectionOne__content_label} ${styles.label} ${styles.textGreen}`}
          >
            Services
          </div>
          <div className={styles.sectionOne__content_title}>
            Lorem ipsum dolor sit amet consectetur.
          </div>
          <div className={styles.sectionOne__content_text}>
            Lorem ipsum dolor sit amet consectetur adipisicing elit. Recusandae,
            porro?
          </div>
        </div>

        <div className={`${styles.sectionOne__cards} container`}>
          <div className={styles.sectionOne__cards__card}>
            <Card
              tag="Basic"
              amount="$100"
              time="/month"
              info="Lorem ipsum dolor sit amet consectetur adipisicing elit. Assumenda possimus asperiores eos distinctio."
              features={[
                "Lorem ipsum dolor sit.",
                "Lorem ipsum dolor sit.",
                "Lorem ipsum dolor sit.",
                "Lorem ipsum dolor sit.",
                "Lorem ipsum dolor sit.",
              ]}
            />
          </div>
          <div className={styles.sectionOne__cards__card}>
            <Card
              tag="Plus"
              amount="$250"
              time="/month"
              info="Lorem ipsum dolor sit amet consectetur adipisicing elit. Assumenda possimus asperiores eos distinctio."
              features={[
                "Lorem ipsum dolor sit.",
                "Lorem ipsum dolor sit.",
                "Lorem ipsum dolor sit.",
                "Lorem ipsum dolor sit.",
                "Lorem ipsum dolor sit.",
              ]}
            />
          </div>
          <div className={styles.sectionOne__cards__card}>
            <Card
              tag="Pro"
              amount="$400"
              time="/month"
              info="Lorem ipsum dolor sit amet consectetur adipisicing elit. Assumenda possimus asperiores eos distinctio."
              features={[
                "Lorem ipsum dolor sit.",
                "Lorem ipsum dolor sit.",
                "Lorem ipsum dolor sit.",
                "Lorem ipsum dolor sit.",
                "Lorem ipsum dolor sit.",
              ]}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

const Card = ({ tag, amount, time, info, features }) => {
  return (
    <div className={styles.card}>
      <div className={styles.tag}>{tag}</div>
      <div className={styles.price}>
        <div className={styles.amount}>{amount}</div>
        <div className={styles.time}>{time}</div>
      </div>
      <div className={styles.info}>{info}</div>
      <div className={styles.features}>
        {features.map((feature, index) => (
          <div className={styles.list} key={index}>
            <i className="bi bi-check-lg"></i>
            <span>{feature}</span>
          </div>
        ))}
      </div>
      <button className={styles.darkBtn}>Learn More</button>
    </div>
  );
};

export default Services;
